/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import KnowledgeService from './idl/knowledge';
import { axiosInstance, type BotAPIRequestConfig } from './axios';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const KnowledgeApi = new KnowledgeService<BotAPIRequestConfig>({
  request: (params, config = {}) => {
    const { headers } = config;
    const reqHeaders = {
      ...headers,
      'Agw-Js-Conv': 'str',
    };
    return axiosInstance.request({ ...params, ...config, headers: reqHeaders });
  },
});

export interface KnowledgeTaskRecoveryResponse {
  code: number;
  operation: string;
  state: string;
  outcome: string;
}

// Keep these existing local routes on the same authenticated HTTP client.
export const knowledgeRecoveryApi = {
  getDocumentRecovery(input: { document_id: string }) {
    const config: BotAPIRequestConfig = {
      url: '/api/knowledge/document/recovery',
      method: 'POST',
      data: input,
      __disableErrorToast: true,
    };
    return axiosInstance.request<unknown, KnowledgeTaskRecoveryResponse>(
      config,
    );
  },
  resumeDocument(input: { document_id: string; operation: string }) {
    const config: BotAPIRequestConfig = {
      url: '/api/knowledge/document/resume',
      method: 'POST',
      data: input,
      __disableErrorToast: true,
    };
    return axiosInstance.request<unknown, KnowledgeTaskRecoveryResponse>(
      config,
    );
  },
};
